import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ContentPageVersionBySlugQueryVariables = Types.Exact<{
  language: Types.Scalars['String']['input'];
  slug1: Types.Scalars['String']['input'];
  slug2: Types.Scalars['String']['input'];
}>;


export type ContentPageVersionBySlugQuery = { __typename?: 'Query', termsDoc: Array<{ __typename?: 'documents', internal_name?: string | null, revisions?: Array<{ __typename?: 'documents_document_revisions', document_revisions_id?: { __typename?: 'document_revisions', version?: string | null } | null } | null> | null }>, privacyDoc: Array<{ __typename?: 'documents', internal_name?: string | null, revisions?: Array<{ __typename?: 'documents_document_revisions', document_revisions_id?: { __typename?: 'document_revisions', version?: string | null } | null } | null> | null }> };


export const ContentPageVersionBySlugDocument = gql`
    query ContentPageVersionBySlug($language: String!, $slug1: String!, $slug2: String!) {
  termsDoc: documents(
    filter: {status: {_eq: "published"}, translations: {slug: {_eq: $slug1}, languages_language_code: {language_code: {_eq: $language}}}}
  ) {
    internal_name
    revisions(
      limit: 1
      filter: {document_revisions_id: {status: {_eq: "published"}}}
    ) {
      document_revisions_id(filter: null) {
        version
      }
    }
  }
  privacyDoc: documents(
    filter: {status: {_eq: "published"}, translations: {slug: {_eq: $slug2}, languages_language_code: {language_code: {_eq: $language}}}}
  ) {
    internal_name
    revisions(
      limit: 1
      filter: {document_revisions_id: {status: {_eq: "published"}}}
    ) {
      document_revisions_id(filter: null) {
        version
      }
    }
  }
}
    `;

/**
 * __useContentPageVersionBySlugQuery__
 *
 * To run a query within a React component, call `useContentPageVersionBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentPageVersionBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentPageVersionBySlugQuery({
 *   variables: {
 *      language: // value for 'language'
 *      slug1: // value for 'slug1'
 *      slug2: // value for 'slug2'
 *   },
 * });
 */
export function useContentPageVersionBySlugQuery(baseOptions: Apollo.QueryHookOptions<ContentPageVersionBySlugQuery, ContentPageVersionBySlugQueryVariables> & ({ variables: ContentPageVersionBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentPageVersionBySlugQuery, ContentPageVersionBySlugQueryVariables>(ContentPageVersionBySlugDocument, options);
      }
export function useContentPageVersionBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentPageVersionBySlugQuery, ContentPageVersionBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentPageVersionBySlugQuery, ContentPageVersionBySlugQueryVariables>(ContentPageVersionBySlugDocument, options);
        }
export function useContentPageVersionBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContentPageVersionBySlugQuery, ContentPageVersionBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentPageVersionBySlugQuery, ContentPageVersionBySlugQueryVariables>(ContentPageVersionBySlugDocument, options);
        }
export type ContentPageVersionBySlugQueryHookResult = ReturnType<typeof useContentPageVersionBySlugQuery>;
export type ContentPageVersionBySlugLazyQueryHookResult = ReturnType<typeof useContentPageVersionBySlugLazyQuery>;
export type ContentPageVersionBySlugSuspenseQueryHookResult = ReturnType<typeof useContentPageVersionBySlugSuspenseQuery>;
export type ContentPageVersionBySlugQueryResult = Apollo.QueryResult<ContentPageVersionBySlugQuery, ContentPageVersionBySlugQueryVariables>;